import { render, staticRenderFns } from "./OppotunityDetail-AllAttachments.vue?vue&type=template&id=10b3a0fa&scoped=true"
import script from "./OppotunityDetail-AllAttachments.vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-AllAttachments.vue?vue&type=script&lang=js"
import style0 from "./OppotunityDetail-AllAttachments.vue?vue&type=style&index=0&id=10b3a0fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3a0fa",
  null
  
)

export default component.exports